// extracted by mini-css-extract-plugin
export default {"formContainer":"add-lead_formContainer__TC7nm","formRow":"add-lead_formRow__bzs3T","formLabel":"add-lead_formLabel__LbdAP","formInput":"add-lead_formInput__-fJki"};